export function mask_cep(value: string) {
  let v = value.replace(/\D/g, "");

  v = v.replace(/^(\d{5})(\d)/, "$1-$2");

  return v;
}
